import { Route, Routes } from "react-router-dom";
import NotFound from "../pages/404";
import AdminLayout from "../layouts/AdminLayout";
import AdminDashboard from "../pages/admin/AdminDashboard";
import AdminEnrolments from "../pages/admin/AdminEnrolments";
import AdminStudents from "../pages/admin/AdminStudents";
import AdminPayments from "../pages/admin/AdminPayments";
import AdminProgress from "../pages/admin/AdminProgress";
import AdminParents from "../pages/admin/AdminParents";
import AdminCurriculum from "../pages/admin/AdminCurriculum";
import AdminShowcase from "../pages/admin/AdminShowcase";
import AdminTeam from "../pages/admin/AdminTeam";
import AdminSettings from "../pages/admin/AdminSettings";
import AdminMessages from "../pages/admin/AdminMessages";
import AdminLessonWeek from "../pages/admin/AdminLessonWeek";
import AdminClusters from "../pages/admin/AdminClusters";
import AdminKits from "../pages/admin/AdminKits";
import AdminReviews from "../pages/admin/AdminReviews";
import AdminReviewDetail from "../pages/admin/AdminReviewDetail";
import AdminShowcasePanel from "../pages/admin/AdminShowcasePanel";

export const AdminRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path="/dashboard" element={<AdminDashboard />} />
        <Route path="/enrolments" element={<AdminEnrolments />} />
        <Route path="/students" element={<AdminStudents />} />
        <Route path="/payments" element={<AdminPayments />} />
        <Route path="/progress" element={<AdminProgress />} />
        <Route path="/parents" element={<AdminParents />} />
        <Route path="/curriculum" element={<AdminCurriculum />} />
        <Route path="/curriculum/:weekKey" element={<AdminLessonWeek />} />
        <Route path="/clusters" element={<AdminClusters />} />
        <Route path="/kits" element={<AdminKits />} />
        <Route path="/reviews" element={<AdminReviews />} />
        <Route path="/reviews/showcases" element={<AdminShowcasePanel />} />
        <Route path="/reviews/:id" element={<AdminReviewDetail />} />
        <Route path="/showcases" element={<AdminShowcase />} />
        <Route path="/messages" element={<AdminMessages />} />
        <Route path="/team" element={<AdminTeam />} />
        <Route path="/settings" element={<AdminSettings />} />

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
